import React from 'react';
import { motion } from 'framer-motion';
export function ForResorts() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-985">
      <div className="max-w-6xl mx-auto px-6" data-id="element-986">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-987">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-988">
            {/* Left: Content */}
            <div data-id="element-989">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-990">
                For Resort Groups
              </p>

              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-8" data-id="element-991">
                Control your distribution
              </h2>

              <p className="text-lg text-stone-400 leading-relaxed mb-12" data-id="element-992">
                Stop letting wholesalers capture your margin. BlockQuote gives
                you the infrastructure to own the direct relationship with
                agencies.
              </p>

              <div className="space-y-8" data-id="element-993">
                <div className="border-l-2 border-red-600 pl-6" data-id="element-994">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-995">
                    Eliminate wholesale leakage
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-996">
                    Shift group bookings to direct distribution — estimated $6M+
                    annual savings per resort group
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-997">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-998">
                    Close groups faster
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-999">
                    Instant quotes vs 48–72hr email cycles. Speed wins business.
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-1000">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1001">
                    Pricing governance
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1002">
                    Enforce rate floors and concession policies automatically
                  </p>
                </div>

                <div className="border-l border-stone-700 pl-6" data-id="element-1003">
                  <p className="text-stone-50 font-medium mb-1" data-id="element-1004">
                    Operational efficiency
                  </p>
                  <p className="text-sm text-stone-400" data-id="element-1005">
                    Reduce manual quoting workload by 60%+ for sales teams
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Data display */}
            <div className="border border-stone-700" data-id="element-1006">
              <div className="border-b border-stone-700 p-6" data-id="element-1007">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-1008">
                  Revenue Dashboard
                </p>
              </div>

              <div className="border-b border-stone-700 p-6" data-id="element-1009">
                <div className="flex justify-between items-baseline mb-2" data-id="element-1010">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1011">
                    Direct Group Revenue
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1012">YTD</p>
                </div>
                <p className="font-mono text-4xl text-stone-50" data-id="element-1013">$4,250,000</p>
                <p className="font-mono text-sm text-red-600 mt-2" data-id="element-1014">+24% YoY</p>
              </div>

              <div className="border-b border-stone-700 p-6" data-id="element-1015">
                <div className="flex justify-between items-baseline mb-2" data-id="element-1016">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1017">
                    Leakage Prevented
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1018">Q4</p>
                </div>
                <p className="font-mono text-4xl text-stone-50" data-id="element-1019">$382,500</p>
              </div>

              <div className="p-6" data-id="element-1020">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1021">
                  Quote Velocity
                </p>
                <div className="flex gap-1 h-3" data-id="element-1022">
                  <div className="bg-red-600 flex-[85]" data-id="element-1023"></div>
                  <div className="bg-stone-700 flex-[15]" data-id="element-1024"></div>
                </div>
                <div className="flex justify-between mt-2" data-id="element-1025">
                  <p className="font-mono text-xs text-stone-500" data-id="element-1026">
                    Instant (85%)
                  </p>
                  <p className="font-mono text-xs text-stone-500" data-id="element-1027">
                    Manual (15%)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}